import {Injectable} from "@angular/core";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../redux-store";
import {AdministrationUnit} from "../view-model/organization/administration-unit.type";
import {AdministrationUnitService} from "../../organization/services/administration_unit_service/administration-unit.service";
import {Observable} from "rxjs/Observable";
import {tap} from "rxjs/operators";

@Injectable()
export class AdminUnitActions {

  static SELECT_ADMIN_UNIT = 'SELECT_ADMIN_UNIT';
  static RETRIEVE_ADMIN_UNIT_DATA = 'RETRIEVE_ADMIN_UNIT_DATA';
  static RETRIEVE_ADMIN_UNIT_DATA_SUCCESS = 'RETRIEVE_ADMIN_UNIT_DATA_SUCCESS';
  static RETRIEVE_ADMIN_UNIT_DATA_ERROR = 'RETRIEVE_ADMIN_UNIT_DATA_ERROR';

  constructor(private adminUnitService: AdministrationUnitService, private ngRedux: NgRedux<IAppState>) {
  }

  public selectAdminUnit(adminUnitCuid: string, adminUnits?: AdministrationUnit[]): AdministrationUnit {
    let adminUnit = adminUnits ? adminUnits.find(unit => unit.cuid == adminUnitCuid) : null;

    this.ngRedux.dispatch({
      type: AdminUnitActions.SELECT_ADMIN_UNIT,
      payload: {cuid: adminUnitCuid}
    });

    this.retrieveAdminUnitData(adminUnitCuid);

    return adminUnit;
  }

  public retrieveAdminUnitData(adminUnitCuid: string | Observable<string>): Observable<any> {

    this.ngRedux.dispatch({
      type: AdminUnitActions.RETRIEVE_ADMIN_UNIT_DATA
    });

    return this.adminUnitService.getAdminUnitDetails(adminUnitCuid).pipe(
      tap(res => {
        this.ngRedux.dispatch({
          type: AdminUnitActions.RETRIEVE_ADMIN_UNIT_DATA_SUCCESS,
          payload: res.data.fetchAdminUnits ? res.data.fetchAdminUnits[0] : null
        });
      }, err => {
        this.ngRedux.dispatch({
          type: AdminUnitActions.RETRIEVE_ADMIN_UNIT_DATA_ERROR
        });
      })
    );

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/actions/admin-unit.actions.ts